/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable new-cap */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import View from 'views/View'
import { faSearch, faFilter, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    Button,
    Collapse,
    Grid,
    Slide,
    IconButton,
    Divider,
    Link,
} from '@mui/material'
import {
    AdvancedFilters,
    UploadRepresentmentsRouter,
    AccentArea,
    MerchantSwitcher,
    CaseFilter,
    FilterAlert,
    AlertDialog,
} from 'components'
import idDirectory from './idAttributes'
import { withRequiredRole } from 'components/useRequireRole'
import { useAuthedUser } from 'context/AuthedUser/AuthedUserContext'
import EntFeature from 'models/EntFeature'
import { useChargebacks } from './Chargebacks.vm'
import { BulkCloseDialog } from './dialogs/BulkCloseDialog'
import { ChargebacksGrid } from './grids/ChargebacksGrid'
import useFeatureToggle from 'hooks/FeatureToggles/useFeatureToggles'
import { SWRContextProvider as ChargebacksContextProvider } from 'context/SWRContext/SWRContext'
import { AdvancedSearchValues } from 'hooks/cb-api/types'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling'
import AlertSnackbar from 'components/AlertSnackbar'
import { EditChargeback } from './modals/EditChargeback'
import { CaseUpdater } from './modals/CaseUpdater'
import spaceshipIcon from 'assets/icons/icon-spaceship.svg'
import { CBNewRelic } from 'lib'

/**
 * The Chargebacks view with a datagrid
 */
const Chargebacks = ({ ...props }: any) => {
    const { clientTheme } = useThemeStyling()
    const history = useHistory()

    const {
        // activeMerchantId,
        cases,
        advanceSearchFields,
        advancedSearchValues,
        handleSubmitAdvancedSearch,
        handleClearAdvancedSearch,
        contextMenuItems,
        isUploadOpen,
        closeUpload,
        selectedCaseIds,
        clearSelectedRows,
        handleChangeCaseFilter,
        handleClearCaseFilter,
        rehydrateView,
        canViewPartnerCompanyId,
        canViewIssuerDocs,
        canViewOutcomeVerdicts,
        canViewPlatform,
        disableSelectAll,
        swrActions,
        defaultPayload,
        metricPresets,
        setMetricPresets,
        collapseOpen,
        setCollapseOpen,
        params,
        isLoadingAdvFilterSelect,
        setIsLoadingAdvFilterSelect,
        openEditChargebacksModal,
        setOpenEditChargebacksModal,
        isLoadingAdvFilterFields,
        alertSnackbarMainOpen,
        setAlertSnackbarMainOpen,
        alertSnackbarMainProps,
        setAlertSnackbarMainProps,
    } = useChargebacks(props)

    const { user, userStackConfig } = useAuthedUser()

    const showClientTypeIssuerUI = user?.is_issuer ?? false
    const isReadOnly = user?.is_read_only
    const showAutoAcceptBtn = userStackConfig?.show_cb_auto_accept_btn ?? false
    const showCaseFilterBtn = userStackConfig?.show_cb_case_filter_btn ?? false
    const showPrimaryCasesExpiringXDays =
        userStackConfig?.show_cb_primary_cases_expiring_x_days ?? false

    const [showCaseFiltersDrawer, setCaseFiltersDrawer] = useState(false)
    const [bulkCloseOpen, setBulkCloseOpen] = useState(false)
    const { HELP_LINK } = useFeatureToggle('CHARGEBACKS')
    const {
        enabled: helpLinkEnabled,
        text: helpLinkText,
        url: helpLinkURL,
    } = HELP_LINK
    const [alertFilterOpen, setAlertFilterOpen] = useState<boolean>(false)
    const [caseFilterOn, setCaseFilterOn] = useState<boolean>(false)
    const [openAlertMsgBanner, setOpenAlertMsgBanner] = useState<boolean>(false)
    const [openCaseUpdaterModal, setOpenCaseUpdaterModal] = useState<boolean>(
        false
    )
    const [openAlertDialog, setOpenAlertDialog] = useState<boolean>(false)
    const { unselectAllRows } = swrActions

    const showCaseUpdaterBtn = [
        'partner_admin',
        'merchant_admin',
        'cb911_admin',
    ].includes(user?.role?.alias ?? '')

    const handleFilterAlert = (filters: AdvancedSearchValues) => {
        Object.values(filters).some((item) => item.length && item !== 'eq')
            ? setAlertFilterOpen(true)
            : setAlertFilterOpen(false)
    }

    const handleOnCloseAlertBanner = async () => {
        setOpenAlertMsgBanner(false)
        try {
            await axios.post(`/users/pro-service/banner/close`, {
                page: 'cb',
            })
        } catch (error) {}
    }

    const handleLearnMore = async () => {
        history.push('/case-management')
        setOpenAlertMsgBanner(false)
        try {
            await axios.post(`/users/pro-service/banner/close`, {
                page: 'cb',
            })
            await CBNewRelic.sendNewRelicEvent({
                key: 'pro-service',
                case_id: null,
                event_name:
                    'Case Management learn more button clicked on chargebacks page',
                event_action: 'clicked',
                event_message:
                    'Case Management learn more button clicked on chargebacks page',
            })
        } catch (error) {}
    }

    useEffect(() => {
        axios
            .get('/users/pro-service/banner', {
                params: {
                    page: 'cb',
                },
            })
            .then(({ data }) => {
                setOpenAlertMsgBanner(Boolean(data?.show))
            })
    }, [])

    return (
        <ChargebacksContextProvider SWRActions={swrActions}>
            <View
                title="Chargebacks"
                breadcrumb="Chargebacks"
                HeaderInterior={<MerchantSwitcher testId="chargebacks" />}
                MiddleInterior={
                    openAlertMsgBanner ? (
                        <div className={'emp-alertBannerContainer'}>
                            <div className={'emp-alertBannerText'}>
                                <img src={spaceshipIcon} alt="spaceship-icon" />
                                <div>
                                    <span
                                        style={{
                                            fontWeight: 600,
                                            color: '#ff0000',
                                        }}
                                    >
                                        Case Manager is now live on your
                                        account!
                                    </span>{' '}
                                    This new tool includes all of the features
                                    you are currently using, with a fresh
                                    interface and improved team collaboration.
                                </div>
                            </div>
                            <div className={'emp-alertBannerActions'}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size={'small'}
                                    className={'emp-alertBannerBtn'}
                                    onClick={handleLearnMore}
                                >
                                    Learn More
                                </Button>
                                <IconButton
                                    size="small"
                                    onClick={handleOnCloseAlertBanner}
                                    className={'emp-alertBannerClose'}
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </IconButton>
                            </div>
                        </div>
                    ) : null
                }
                testId="chargebacks"
            >
                <Grid
                    id={idDirectory.gridContainer}
                    container
                    spacing={1}
                    className={'emp-gridWrapperDefault'}
                >
                    <Grid
                        id={`${idDirectory.gridItem}-chargebacks`}
                        item
                        xs={12}
                        lg={
                            showCaseFiltersDrawer
                                ? 9
                                : collapseOpen
                                ? 12
                                : undefined
                        }
                    >
                        <AccentArea
                            testId={'chargebacks-cbHeader'}
                            className={'emp-accentArea'}
                            containsFullWidthGrid={true}
                            hasHeaderDivider={false}
                        >
                            <div className="emp-topContainer">
                                <div>
                                    <Button
                                        id={idDirectory.btnAdvSearch}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() =>
                                            setCollapseOpen(!collapseOpen)
                                        }
                                        className={`emp-advSearchBtn`}
                                        disabled={
                                            isLoadingAdvFilterFields ||
                                            !advanceSearchFields.length
                                        }
                                    >
                                        <span className={'emp-advSearchIcon'}>
                                            <FontAwesomeIcon icon={faSearch} />
                                        </span>
                                        &nbsp; Advanced Search
                                    </Button>
                                    {showCaseFilterBtn && (
                                        <Button
                                            id={idDirectory.btnCaseFilter}
                                            variant="contained"
                                            color="secondary"
                                            onClick={() =>
                                                setCaseFiltersDrawer(
                                                    !showCaseFiltersDrawer
                                                )
                                            }
                                            className={`emp-caseFilterBtn`}
                                            sx={[
                                                showCaseFiltersDrawer && {
                                                    backgroundColor:
                                                        clientTheme.secondaryDark,
                                                },
                                            ]}
                                        >
                                            Case Filters
                                        </Button>
                                    )}
                                    {!showAutoAcceptBtn ? null : (
                                        <Button
                                            id={idDirectory.btnAutoAccept}
                                            variant="contained"
                                            onClick={() =>
                                                setBulkCloseOpen(true)
                                            }
                                            className={'emp-autoAcceptBtn'}
                                            disabled={isReadOnly}
                                            sx={
                                                clientTheme.buttons.greyButton
                                                    .style
                                            }
                                        >
                                            Auto Accept
                                        </Button>
                                    )}

                                    {!helpLinkEnabled ? null : (
                                        <a
                                            className={'emp-helpLink'}
                                            href={helpLinkURL}
                                            rel="external noopener noreferrer"
                                            target="_blank"
                                        >
                                            {helpLinkText}
                                        </a>
                                    )}
                                    <div className={'emp-filterAlertContainer'}>
                                        {alertFilterOpen && <FilterAlert />}
                                    </div>
                                </div>
                                {showCaseUpdaterBtn && (
                                    <div>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                setOpenCaseUpdaterModal(true)
                                            }}
                                            className="emp-caseUpdaterBtn"
                                        >
                                            Case Updater
                                        </Button>
                                    </div>
                                )}
                            </div>
                            <Divider className={'emp-divider'} />
                            <Collapse in={collapseOpen} timeout="auto">
                                <div
                                    className={'emp-advancedFilterContent'}
                                    style={{
                                        background:
                                            clientTheme.mainLayout
                                                .backgroundColor,
                                    }}
                                >
                                    {Boolean(advanceSearchFields.length) && (
                                        <AdvancedFilters
                                            fields={advanceSearchFields}
                                            metricPresets={metricPresets}
                                            validate={() => ({})}
                                            onSubmit={async (filters) => {
                                                handleFilterAlert(filters)
                                                caseFilterOn &&
                                                    (await handleClearCaseFilter())
                                                setCaseFilterOn(false)
                                                handleSubmitAdvancedSearch(
                                                    filters,
                                                    true
                                                )
                                            }}
                                            onClear={async () => {
                                                caseFilterOn &&
                                                    (await handleClearCaseFilter())
                                                setCaseFilterOn(false)
                                                alertFilterOpen &&
                                                    handleClearAdvancedSearch()
                                                setAlertFilterOpen(false)
                                                setCollapseOpen(false)
                                            }}
                                            initialValues={
                                                advancedSearchValues as Record<
                                                    string,
                                                    string
                                                >
                                            }
                                            isActiveAdvSearchFilters={
                                                alertFilterOpen
                                            }
                                            setIsLoadingAdvFilterSelect={
                                                setIsLoadingAdvFilterSelect
                                            }
                                            inactivateSearchBtn={
                                                swrActions.isLoading
                                            }
                                            caseFilterOn={caseFilterOn}
                                        />
                                    )}
                                </div>
                            </Collapse>
                            {/* isMultiSelect is always true as this upload modal opens from the context menu, not the manual upload icon */}
                            <UploadRepresentmentsRouter
                                cases={cases}
                                caseIds={selectedCaseIds}
                                openModal={isUploadOpen}
                                toggleModal={closeUpload}
                                rehydrateView={rehydrateView}
                                isMultiSelect
                                setAlertSnackbarMainProps={
                                    setAlertSnackbarMainProps
                                }
                                setAlertSnackbarMainOpen={
                                    setAlertSnackbarMainOpen
                                }
                                unselectAllRows={unselectAllRows}
                            />
                            <ChargebacksGrid
                                data={cases}
                                contextMenuItems={contextMenuItems}
                                canViewPartnerCompanyId={
                                    canViewPartnerCompanyId
                                }
                                canViewIssuerDocs={canViewIssuerDocs}
                                canViewOutcomeVerdicts={canViewOutcomeVerdicts}
                                canViewPlatform={canViewPlatform}
                                disableSelectAllCheckbox={disableSelectAll}
                                params={params}
                                clearSelectedRows={clearSelectedRows}
                                setAlertSnackbarMainProps={
                                    setAlertSnackbarMainProps
                                }
                                setAlertSnackbarMainOpen={
                                    setAlertSnackbarMainOpen
                                }
                                isLoadingAdvFilters={
                                    isLoadingAdvFilterSelect ||
                                    isLoadingAdvFilterFields
                                }
                                showClientTypeIssuerUI={showClientTypeIssuerUI}
                            />
                        </AccentArea>
                    </Grid>
                    <Slide
                        direction="left"
                        in={showCaseFiltersDrawer}
                        mountOnEnter
                        unmountOnExit
                        style={{
                            position: 'sticky',
                            top: '60px',
                        }}
                    >
                        <Grid
                            id={`${idDirectory.gridItem}-caseFilter`}
                            item
                            xs={12}
                            lg={3}
                        >
                            <AccentArea
                                testId={'chargebacks-caseFilter'}
                                title={
                                    <>
                                        <FontAwesomeIcon
                                            icon={faFilter}
                                            className={'emp-marginRight'}
                                        />
                                        <span>Case Filters</span>
                                    </>
                                }
                                className={'emp-caseFilterArea'}
                            >
                                <CaseFilter
                                    title="Queue"
                                    onClose={() => setCaseFiltersDrawer(false)}
                                    defaultPayload={defaultPayload}
                                    handleChangeCaseFilter={(filters) => {
                                        setCaseFilterOn(true)
                                        handleChangeCaseFilter(filters)
                                    }}
                                    handleClearCaseFilter={() => {
                                        setCaseFilterOn(false)
                                        handleClearCaseFilter()
                                    }}
                                    isActiveAdvSearchFilters={alertFilterOpen}
                                    handleClearAdvancedSearch={() => {
                                        setAlertFilterOpen(false)
                                        handleClearAdvancedSearch()
                                    }}
                                    setMetricPresets={setMetricPresets}
                                    setAlertFilterOpen={setAlertFilterOpen}
                                    setAlertSnackbarMainProps={
                                        setAlertSnackbarMainProps
                                    }
                                    setAlertSnackbarMainOpen={
                                        setAlertSnackbarMainOpen
                                    }
                                    showPrimaryCasesExpiringXDays={
                                        showPrimaryCasesExpiringXDays
                                    }
                                />
                            </AccentArea>
                        </Grid>
                    </Slide>
                </Grid>
                <BulkCloseDialog
                    open={bulkCloseOpen}
                    onClose={() => setBulkCloseOpen(false)}
                />
                {openEditChargebacksModal && (
                    <EditChargeback
                        openModal={openEditChargebacksModal}
                        onClose={() => setOpenEditChargebacksModal(false)}
                        caseIds={selectedCaseIds}
                        rehydrateView={rehydrateView}
                        setAlertSnackbarMainProps={setAlertSnackbarMainProps}
                        setAlertSnackbarMainOpen={setAlertSnackbarMainOpen}
                        enableBulkAction
                        unselectAllRows={unselectAllRows}
                    />
                )}
                {openCaseUpdaterModal && (
                    <CaseUpdater
                        openCaseUpdater={openCaseUpdaterModal}
                        onClose={() => setOpenCaseUpdaterModal(false)}
                        setOpenAlertDialog={setOpenAlertDialog}
                        setAlertSnackbarMainProps={setAlertSnackbarMainProps}
                        setAlertSnackbarMainOpen={setAlertSnackbarMainOpen}
                    />
                )}
                <AlertSnackbar
                    content={alertSnackbarMainProps}
                    open={alertSnackbarMainOpen}
                    onClose={() => setAlertSnackbarMainOpen(false)}
                    showCloseIcon
                />
                <AlertDialog
                    content={{
                        title: 'Success',
                        intent: 'success',
                        message: '',
                    }}
                    open={openAlertDialog}
                    onClose={() => setOpenAlertDialog(false)}
                    enableAutoClose={false}
                    disableBackdropClick={true}
                    additionalContent={
                        <div>
                            We have processed your file.{' '}
                            <Link
                                className={'emp-downloadLink'}
                                href={''}
                                sx={{ color: clientTheme.secondaryLight }}
                            >
                                Download Case Updater Report
                            </Link>
                        </div>
                    }
                />
            </View>
        </ChargebacksContextProvider>
    )
}

export default withRequiredRole(EntFeature.CHARGEBACKS, Chargebacks)
